import { Outlet, useNavigate } from "react-router-dom";
import ContainerNavigation from "../../components/ContainerNavigation";
import { useNavigationBar } from "../../context/NavigationContext";

import CreateArtifactProvider, { CreateArtifactContext } from "../../context/CreateArtifactContext";
import { useContext } from "react";
import { ContentState, getContentEditStatusString, getContentStatusString } from "../../models/SKArtifact";

interface ArtifactContextLayoutProps {
  isEditingModeration?: boolean;
}
const ArtifactContextLayout = ({ isEditingModeration = false }: ArtifactContextLayoutProps) => {
  const navContext = useNavigationBar();
  const navigate = useNavigate();

  // const { showModal, confirmNavigation, cancelNavigation } = usePrompt("Are you sure you want to leave this page?", true);
  const {
    backArrow,
    title,
    subtitle,
    userActions,
    buttonTitle,
    enableLink,
    onBack,
    onClose,
    icon,
    onFilter,
    onNext,
    getActionItems,
    onActionItemSelect,
  } = navContext.navProps;

  // useEffect(() => {
  //   if (blocker.state === "blocked") {
  //     blocker.reset();
  //   }
  // }, [blocker]);

  return (
    <CreateArtifactProvider isModerator={true} isContentEditing={isEditingModeration}>
      <div className="container-modal">
        <div className="container-modal-content">
          <div className="bg-white md:p-4">
            <div>
              <ContainerNavigation
                backArrow={backArrow}
                title={title}
                subtitle={subtitle}
                userActions={userActions}
                icon={icon}
                enableLink={enableLink}
                buttonTitle={buttonTitle}
                onBack={onBack}
                onClose={onClose}
                getActionItems={getActionItems}
                onActionItemSelect={onActionItemSelect}
              />
              <div className="left-0 flex flex-col w-full h-screen overflow-y-auto top-[84px] pb-48">
                <ContentStatus />
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
    </CreateArtifactProvider>
  );
};

// const ContentStatus = () => {
//   const { contentData } = useContext(CreateArtifactContext);

//   return (
//     <>
//       <div className="flex items-center justify-end mt-[5px]">
//         <div className="flex items-center">
//           {contentData.status === ContentState.IN_REVIEW && <span className="bg-skgreen w-[8px] h-[8px] rounded-full"></span>}
//           <p className="ml-1 capitalize">{getContentStatusString(contentData.status, contentData.subStatus)}</p>
//         </div>
//       </div>
//     </>
//   );
// };

const ContentStatus = () => {
  const { contentData, originalState, isContentEditing } = useContext(CreateArtifactContext);

  return (
    <>
      {contentData && (
        <div className={`flex items-center gap-5 justify-end p-[3px] pr-3 ${isContentEditing ? "!bg-[#FFCC00] h-[28px] mb-[35px]" : ""} `}>
          {/* {contentData?.reactCount ? (
            <div className="flex items-center gap-1">
              <span className="">👍</span>
              <span className="capitalize edit-status-top  !text-sm !font-normal">{contentData.reactCount}</span>
            </div>
          ) : (
            <></>
          )}
          {contentData?.likeCount ? (
            <div className="flex items-center gap-1">
              <span className="text-red-500 ">❤️</span>
              <span className="capitalize edit-status-top !text-sm !font-normal">{contentData.likeCount}</span>
            </div>
          ) : (
            <></>
          )}
          {contentData?.bookmarkCount ? (
            <div className="flex items-center gap-1">
              <span className="text-sm">Bookmarks</span>
              <span className="capitalize edit-status-top !text-sm !font-normal">{contentData.bookmarkCount}</span>
            </div>
          ) : (
            <></>
          )} */}
          <div className="flex items-center gap-1">
            <p className="capitalize edit-status-top">
              {isContentEditing && originalState?.subStatus
                ? getContentEditStatusString(originalState.subStatus)
                : getContentStatusString(contentData?.status, contentData.subStatus)}
            </p>
            {!isContentEditing && contentData?.status === ContentState.ACTIVE && (
              <span>
                <img src={"/icons/CheckItem.png"} className="object-contain w-[14px] h-[14px] min-w-5" alt="Certification status" />
              </span>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ArtifactContextLayout;
